export default "__VITE_ASSET__CPzubmpm__"